export const listType = {
  grid: "grid",
  list: "list",
};

export const tabs = {
  favorite: "favorite",
  home: "home",
  category: "category",
};
